import { FunctionComponent } from 'react';

import { Button, Icon, Loader, Text } from '@kanda-libs/ks-design-library';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useDeclined from './useDeclined';

const Declined: FunctionComponent = () => {
  const {
    failureUrl,
    companyName,
    provider,
    hasAppliedSecond,
    errorMessage,
    isLoading,
    isSubmitting,
  } = useDeclined();

  return (
    <PleaseWaitOverlay
      icon="currency"
      iconClassName="text-red-200 mb-4"
      title={`Unfortunately, your finance application was declined by the lender: ${provider}`}
      labelLine1={`${companyName} has been notified that your finance application was declined. If you still want the work to go ahead without finance, please get in touch with ${companyName}.`}
      footer={
        <>
          {errorMessage && (
            <div className="flex flex-row gap-x-3 p-3 md:px-5 md:py-4 border border-red-200 bg-red-100 rounded-lg mb-6">
              <Icon
                icon="info"
                stroke="red-200"
                className="w-5 h-5 min-w-5 min-h-5 mb-auto"
              />
              <p className="text-14-22-em text-red-200">{errorMessage}</p>
            </div>
          )}
          {failureUrl && (
            <>
              <Text
                text={`If you would like to be redirected back to ${companyName}'s website, you can click the below button.${
                  hasAppliedSecond
                    ? ' You will automatically be redirected in 10 seconds'
                    : ''
                }`}
                className="mt-10 mb-4 text-14-22 text-neutral-600 md:mb-6"
                isLoading={isLoading}
              />
              <a href={failureUrl} className="flex w-full">
                <Button.Text
                  id="declined-return-to-website"
                  label="Return to website"
                  className="w-full"
                  disabled={isSubmitting}
                />
              </a>
            </>
          )}
          <Loader isLoading={isSubmitting} />
        </>
      }
    />
  );
};

export default Declined;
